<div class="email-header-block"
  [ngStyle]="{
    'background-color': color
  }">
  <div *ngIf="editable">
    <yc-rich-text-editor
      name="title"
      [isInline]="true"
      [tokenInsertionOnly]="true"
      [inlineStyle]="InlineStyle.Header_Block"
      [tokenToInsert]="tokenToInsert"
      [stripHtml]="true"
      (onChange)="onChange($event)"
      (onEditorBlur)="onEditorBlur.emit()">
    </yc-rich-text-editor>
  </div>

  <div *ngIf="!editable">
    {{ title }}
  </div>
</div>
